import type { ReactNode } from 'react';

export const symbol_soba: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M225-80q-39 0-70-24t-40-62L89-271q-4-14 5.5-25.5T118-308h28q2-14 5.5-27t8.5-26v-412q0-11 8-19.5t19-10.5l666-74q11-2 19 6t8 19q0 10-6 16.5t-16 7.5l-448 50v87h445q11 0 18 7t7 18q0 11-7 18t-18 7H410v68q17-4 34.5-5.5T480-580q125 0 219 77t116 195h27q14 0 23.5 11.5T871-271l-26 105q-10 38-40 62t-69 24H225Zm0-60h511q18 0 32-11.5t19-29.5l16-67H157l16 67q4 18 18.5 29.5T225-140Zm-19-168h88q20-56 71-90.5T480-433q64 0 115 34.5t71 90.5h88q-21-92-97.5-152T480-520q-100 0-176.5 60T206-308Zm156 0h236q-17-29-48.5-47T480-373q-38 0-69.5 18T362-308ZM210-450q11-14 23.5-27t26.5-24v-140h-50v191Zm100-86q12-7 24.5-12.5T360-559v-82h-50v105ZM210-691h50v-71l-50 6v65Zm100 0h50v-82l-50 6v76Zm170 443Z"
		/>
	</svg>
);
